import { render, staticRenderFns } from "./CourseInfo.html?vue&type=template&id=9e214378&scoped=true&external"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"
import style0 from "./CourseInfo.scss?vue&type=style&index=0&id=9e214378&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e214378",
  null
  
)

export default component.exports